export var PaymentMethods;

(function (PaymentMethods) {
  PaymentMethods["PAY_AT_RESTAURANT"] = "payatrest";
  PaymentMethods["ONLINE"] = "online";
})(PaymentMethods || (PaymentMethods = {}));

export var FallbackReasonCode;

(function (FallbackReasonCode) {
  FallbackReasonCode["CC_TOKENIZATION_FAILURE"] = "CC_TOKENIZATION_FAILURE";
  FallbackReasonCode["ERROR_SESSION_TOKEN_FAILURE"] = "ERROR_SESSION_TOKEN_FAILURE";
  FallbackReasonCode["GOOGLEPAY_INIT_FAILURE"] = "GOOGLEPAY_INIT_FAILURE";
  FallbackReasonCode["APPLEPAY_INIT_FAILURE"] = "APPLEPAY_INIT_FAILURE";
  FallbackReasonCode["PAYPAL_INIT_FAILURE"] = "PAYPAL_INIT_FAILURE";
  FallbackReasonCode["GOOGLEPAY_DP_FAILURE"] = "GOOGLEPAY_DP_FAILURE";
  FallbackReasonCode["APPLEPAY_DP_FAILURE"] = "APPLEPAY_DP_FAILURE";
  FallbackReasonCode["PAYPAL_DP_FAILURE"] = "PAYPAL_DP_FAILURE";
})(FallbackReasonCode || (FallbackReasonCode = {}));

export var OnlinePaymentTypes;

(function (OnlinePaymentTypes) {
  OnlinePaymentTypes["CREDIT_CARD"] = "cc";
  OnlinePaymentTypes["PAYPAL"] = "paypal";
  OnlinePaymentTypes["GOOGLE_PAY"] = "gp";
  OnlinePaymentTypes["APPLE_PAY"] = "ap";
  OnlinePaymentTypes["NONE"] = "none";
})(OnlinePaymentTypes || (OnlinePaymentTypes = {}));

export var PickupMethod;

(function (PickupMethod) {
  PickupMethod["CARSIDE"] = "CARSIDE";
  PickupMethod["IN_RESTAURANT"] = "IN_RESTAURANT";
})(PickupMethod || (PickupMethod = {}));

export var PaymentFlow;

(function (PaymentFlow) {
  PaymentFlow["CHECKOUT"] = "CHECKOUT";
  PaymentFlow["GC_CHECKOUT"] = "GC_CHECKOUT";
  PaymentFlow["MPAY_CLQ"] = "CLQ";
  PaymentFlow["MPAY_TLQ"] = "TLQ";
  PaymentFlow["MPAY_OPCIO"] = "OPCIO";
  PaymentFlow["PROFILE"] = "PROFILE";
})(PaymentFlow || (PaymentFlow = {}));

export var MPAnalyticsPaymentMethod;

(function (MPAnalyticsPaymentMethod) {
  MPAnalyticsPaymentMethod["GIFT"] = "giftCard";
  MPAnalyticsPaymentMethod["CREDIT"] = "creditCard";
  MPAnalyticsPaymentMethod["PAYPAL"] = "PayPal";
  MPAnalyticsPaymentMethod["APPLEPAY"] = "ApplePay";
  MPAnalyticsPaymentMethod["GOOGLEPAY"] = "GooglePay";
})(MPAnalyticsPaymentMethod || (MPAnalyticsPaymentMethod = {}));

export var DialogueCodes;

(function (DialogueCodes) {
  DialogueCodes["CHARGE_BACK_GUEST"] = "901";
  DialogueCodes["PAYMENT_CODE_BLACKLISTED_IN_APP"] = "810";
  DialogueCodes["PAYMENT_CODE_REGEX_VALIDATION"] = "201";
  DialogueCodes["PAYMENT_CODE_INVALID_API"] = "202";
  DialogueCodes["CONNECTIVITY_ERROR"] = "501";
  DialogueCodes["CHECK_CLOSED"] = "111";
  DialogueCodes["CHECK_SATISFIED"] = "601";
  DialogueCodes["CHECK_NOT_FOUND"] = "011";
  DialogueCodes["FRAUD_SUSPICION_LOCK"] = "701";
  DialogueCodes["MAX_THRESHOLD_ERROR"] = "999";
  DialogueCodes["PAYMENT_FAILURE_THRESHOLD_ERROR"] = "310";
  DialogueCodes["PAYMENT_LOAD_CHECK_ERROR"] = "701";
  DialogueCodes["PAYMENT_LOCK_ORDER_ERROR"] = "001";
  DialogueCodes["PAYMENT_INVALID_CODE_ERROR"] = "191";
  DialogueCodes["PAYMENT_CONNECTIVITY_ERROR"] = "501";
  DialogueCodes["PAYMENT_CLOSED_CHECK"] = "111";
  DialogueCodes["PAYMENT_DFP_REJECT"] = "444";
  DialogueCodes["CHECK_ALREADY_PAID"] = "666";
  DialogueCodes["ERROR_CASE_MISSING"] = "667";
  DialogueCodes["TLQ_NOT_ENABLED_ERROR"] = "668";
  DialogueCodes["ERROR_AVAILABLE_ON_APP"] = "557";
  DialogueCodes["ERROR_AVAILABLE_ON_WEB"] = "558";
  DialogueCodes["ERROR_MOBILE_PAY_NOT_AVAILABLE"] = "559";
  DialogueCodes["MULTIPLE_CHECKS_FOUND"] = "012";
  DialogueCodes["ERROR_APPLY_COUPON_FAILURE"] = "340";
  DialogueCodes["ERROR_REMOVE_COUPON"] = "341";
  DialogueCodes["ERROR_COUPON_NOT_APPLICABLE_OR_INVALID"] = "342";
  DialogueCodes["ERROR_CHECK_VERSION_MISMATCH"] = "013";
  DialogueCodes["PAYPAL_PAYMENT_FAILED"] = "412";
  DialogueCodes["PAYPAL_AUTHORIZATION_FAILED"] = "413";
  DialogueCodes["PAYPAL_PAYMENT_CANCELLED"] = "414";
  DialogueCodes["ERROR_CC_TOKENIZATION_BUSINESS_FAULT"] = "451";
  DialogueCodes["ERROR_CC_TOKENIZATION_TECHNICAL_FAILURE"] = "452";
  DialogueCodes["ERROR_ORDER_SESSION_TOKEN_FAILURE"] = "453";
  DialogueCodes["ERROR_PAY_AT_RESTAURANT_NOT_SUPPORTED"] = "454";
  DialogueCodes["ERROR_INVALID_ORDER_TOTAL"] = "455";
  DialogueCodes["ERROR_CHECK_NOT_LOADED"] = "456";
  DialogueCodes["ERROR_ERROR_CHECK_OVER_PAID"] = "471";
  DialogueCodes["ERROR_MERCHANT_ID_NOT_FOUND"] = "472";
  DialogueCodes["ERROR_GENERIC_PAYMENT_FAILURE"] = "473";
  DialogueCodes["ERROR_PAYMENT_EXCEPTIONS"] = "474";
  DialogueCodes["ERROR_FRAUD_PAYMENT_TOKEN"] = "475";
  DialogueCodes["ERROR_DFP_CHECK_LOCKED"] = "476";
  DialogueCodes["ERROR_BAMS_ERROR_RESPONSE"] = "477";
  DialogueCodes["ERROR_SESSION_EXPIRY"] = "321";
  DialogueCodes["ERROR_CUSTOM_GRATUITY_THRESHOLD_EXCEEDS"] = "979";
  DialogueCodes["ERROR_SUBMIT_ORDER_FAIL"] = "802";
  DialogueCodes["ERROR_FAULTS_NOT_HANDLED"] = "669";
  DialogueCodes["GOOGLE_PAY_PAYMENT_FAILED"] = "432";
  DialogueCodes["GOOGLE_PAY_AUTHORIZATION_FAILED"] = "433";
  DialogueCodes["GOOGLE_PAY_PAYMENT_CANCELLED"] = "434";
  DialogueCodes["APPLE_PAY_PAYMENT_FAILED"] = "422";
  DialogueCodes["APPLE_PAY_AUTHORIZATION_FAILED"] = "423";
  DialogueCodes["APPLE_PAY_PAYMENT_CANCELLED"] = "424";
  DialogueCodes["ERROR_SHORT_TOKEN_SUMMARY"] = "645";
  DialogueCodes["ERROR_SHORT_TOKEN_MISSING"] = "646";
  DialogueCodes["ERROR_SEND_MAIL_RECEIPT_FAILED"] = "723";
  DialogueCodes["SEND_MAIL_RECEIPT_SUCCESS"] = "722";
  DialogueCodes["ERROR_DRI_570"] = "478";
  DialogueCodes["LARGE_PARTY_CHECKS_FOUND"] = "014";
  DialogueCodes["ERROR_CHECK_TOTAL_ZERO"] = "015";
})(DialogueCodes || (DialogueCodes = {}));

export var LocationServiceStatus;

(function (LocationServiceStatus) {
  LocationServiceStatus["NEVER"] = "Never";
  LocationServiceStatus["ASK_NEXT_TIME"] = "Ask next time";
  LocationServiceStatus["WHILE_USING_THE_APP"] = "While using the app";
  LocationServiceStatus["ALWAYS"] = "Always";
})(LocationServiceStatus || (LocationServiceStatus = {}));

export var CheckoutDialogueCodes;

(function (CheckoutDialogueCodes) {
  CheckoutDialogueCodes["ERROR_CASE_MISSING"] = "001";
})(CheckoutDialogueCodes || (CheckoutDialogueCodes = {}));

export var MobilePayLoadCheckFailure;

(function (MobilePayLoadCheckFailure) {
  MobilePayLoadCheckFailure["TLQ_NOT_ENABLED_ERROR"] = "PS431";
  MobilePayLoadCheckFailure["ERROR_PAYMENT_CODE_NOT_FOUND"] = "MP414";
  MobilePayLoadCheckFailure["ERROR_CHECK_NOT_FOUND"] = "ERROR_CHECK_NOT_FOUND";
  MobilePayLoadCheckFailure["checkNotFound"] = "PS430";
  MobilePayLoadCheckFailure["ERROR_AVAILABLE_ON_APP"] = "MP415";
  MobilePayLoadCheckFailure["ERROR_AVAILABLE_ON_WEB"] = "PS414";
  MobilePayLoadCheckFailure["ERROR_CHECK_SATISFIED"] = "PS419";
  MobilePayLoadCheckFailure["checkSatisfiedError"] = "PS420";
  MobilePayLoadCheckFailure["ERROR_CHECK_CLOSED"] = "PS421";
  MobilePayLoadCheckFailure["checkClosed"] = "PS422";
  MobilePayLoadCheckFailure["ERROR_MOBILE_PAY_NOT_AVAILABLE"] = "MP416";
  MobilePayLoadCheckFailure["ERROR_CHECK_TOTAL_THRESHOLD"] = "PS426";
  MobilePayLoadCheckFailure["connectivityError"] = "PS423";
  MobilePayLoadCheckFailure["tlqNoCheckFound"] = "PS424";
  MobilePayLoadCheckFailure["tlqMultipleChecksFound"] = "PS428";
  MobilePayLoadCheckFailure["tlqLargePartyChecksFound"] = "PS427";
  MobilePayLoadCheckFailure["ERROR_CHECK_TOTAL_ZERO"] = "PS425";
  MobilePayLoadCheckFailure["PAYMENT_CODE_BLANK"] = "MP414";
})(MobilePayLoadCheckFailure || (MobilePayLoadCheckFailure = {}));

export var MobilePayPaymentFailure;

(function (MobilePayPaymentFailure) {
  MobilePayPaymentFailure["DRI-570"] = "DRI-570";
  MobilePayPaymentFailure["DRI_570"] = "DRI_570";
  MobilePayPaymentFailure["ERROR_CHECK_OVER_PAID"] = "ERROR_CHECK_OVER_PAID";
  MobilePayPaymentFailure["ERROR_MERCHANT_ID_NOT_FOUND"] = "MERCHANTID_NOT_FOUND";
  MobilePayPaymentFailure["paymentExceptions"] = "paymentExceptions";
  MobilePayPaymentFailure["ERROR_GENERIC_PAYMENT_FAILURE"] = "ERROR_GENERIC_PAYMENT_FAILURE";
  MobilePayPaymentFailure["dfpRejectType"] = "dfpRejectType";
  MobilePayPaymentFailure["fraudPaymentToken"] = "fraudPaymentToken";
  MobilePayPaymentFailure["ERROR_DFP_CHECK_LOCKED"] = "ERROR_DFP_CHECK_LOCKED";
  MobilePayPaymentFailure["bamsErrorResponse"] = "bamsErrorResponse";
  MobilePayPaymentFailure["ERROR_CHECK_NOT_FOUND"] = "ERROR_CHECK_NOT_FOUND";
  MobilePayPaymentFailure["ERROR_CHECK_CLOSED"] = "ERROR_CHECK_CLOSED";
  MobilePayPaymentFailure["ERROR_CHECK_VERSION_MISMATCH"] = "ERROR_CHECK_VERSION_MISMATCH";
  MobilePayPaymentFailure["ERROR_CHECK_LOCKED"] = "ERROR_CHECK_LOCKED";
  MobilePayPaymentFailure["sessionExpired"] = "sessionExpired";
  MobilePayPaymentFailure["CHECK_NOT_LOADED"] = "CHECK_NOT_LOADED";
  MobilePayPaymentFailure["ERROR_CHECK_NOT_LOADED"] = "ERROR_CHECK_NOT_LOADED";
  MobilePayPaymentFailure["ERROR_CUSTOM_GRATUITY_THRESHOLD_EXCEEDS"] = "ERROR_CUSTOM_GRATUITY_THRESHOLD_EXCEEDS";
  MobilePayPaymentFailure["SubmitOrderFail"] = "SubmitOrderFail";
})(MobilePayPaymentFailure || (MobilePayPaymentFailure = {}));

export var MobilePayCouponErrors;

(function (MobilePayCouponErrors) {
  MobilePayCouponErrors["ERROR_DP_INVALID_COUPON"] = "CRT416";
  MobilePayCouponErrors["ERROR_BFAULT"] = "BFAULT";
  MobilePayCouponErrors["ERROR_TFAULT"] = "TFAULT";
  MobilePayCouponErrors["paymentExceptions"] = "paymentExceptions";
  MobilePayCouponErrors["ERROR_GENERIC_PAYMENT_FAILURE"] = "ERROR_GENERIC_PAYMENT_FAILURE";
  MobilePayCouponErrors["ERROR_GENERIC_COUPON_FAILURE"] = "ERROR_GENERIC_COUPON_FAILURE";
  MobilePayCouponErrors["ERROR_COUPON_MANUAL_OVERRIDE"] = "ERROR_COUPON_MANUAL_OVERRIDE";
  MobilePayCouponErrors["ERROR_CHECK_NOT_FOUND"] = "ERROR_CHECK_NOT_FOUND";
  MobilePayCouponErrors["checkNotFound"] = "checkNotFound";
  MobilePayCouponErrors["ERROR_CHECK_CLOSED"] = "ERROR_CHECK_CLOSED";
  MobilePayCouponErrors["closedCheck"] = "closedCheck";
  MobilePayCouponErrors["ERROR_CHECK_SATISFIED"] = "ERROR_CHECK_SATISFIED";
  MobilePayCouponErrors["checkSatisfiedError"] = "checkSatisfiedError";
  MobilePayCouponErrors["couponExceptions"] = "couponExceptions";
  MobilePayCouponErrors["ERROR_COUPON_NOT_APPLICABLE"] = "ERROR_COUPON_NOT_APPLICABLE";
  MobilePayCouponErrors["ERROR_INVALID_COUPON"] = "ERROR_INVALID_COUPON";
  MobilePayCouponErrors["ERROR_CHECK_LOCKED"] = "ERROR_CHECK_LOCKED";
  MobilePayCouponErrors["ERROR_CHECK_VERSION_MISMATCH"] = "ERROR_CHECK_VERSION_MISMATCH";
  MobilePayCouponErrors["lockOrderError"] = "lockOrderError";
})(MobilePayCouponErrors || (MobilePayCouponErrors = {}));

export var TOGO_DELIVERY_ERROR_POP_UP_TYPE;

(function (TOGO_DELIVERY_ERROR_POP_UP_TYPE) {
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_PAYMENT_FAILED"] = 0] = "ERROR_PAYMENT_FAILED";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_ORDER_FAILED"] = 1] = "ERROR_ORDER_FAILED";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_LOCATION_NOT_DELIVERABLE"] = 2] = "ERROR_LOCATION_NOT_DELIVERABLE";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_REQUEST_FAILED"] = 3] = "ERROR_REQUEST_FAILED";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_TIME_UPDATED"] = 4] = "ERROR_TIME_UPDATED";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_DELIVERY_UNAVAILABLE"] = 5] = "ERROR_DELIVERY_UNAVAILABLE";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["ERROR_UNABLE_TO_DELIVER"] = 6] = "ERROR_UNABLE_TO_DELIVER";
  TOGO_DELIVERY_ERROR_POP_UP_TYPE[TOGO_DELIVERY_ERROR_POP_UP_TYPE["NONE"] = 7] = "NONE";
})(TOGO_DELIVERY_ERROR_POP_UP_TYPE || (TOGO_DELIVERY_ERROR_POP_UP_TYPE = {}));

export var DELIVERY_TIME_UPDATED_USER_DECISION;

(function (DELIVERY_TIME_UPDATED_USER_DECISION) {
  DELIVERY_TIME_UPDATED_USER_DECISION[DELIVERY_TIME_UPDATED_USER_DECISION["SWITCH"] = 0] = "SWITCH";
  DELIVERY_TIME_UPDATED_USER_DECISION[DELIVERY_TIME_UPDATED_USER_DECISION["CONTINUE"] = 1] = "CONTINUE";
})(DELIVERY_TIME_UPDATED_USER_DECISION || (DELIVERY_TIME_UPDATED_USER_DECISION = {}));